// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l4x_","left":"styles_left__1QZB8"};